import { confirmAlert } from 'react-confirm-alert';

import { ConfirmDeletionDialog } from './ConfirmDeletionDialog';
import type { ConfirmDeletionDialogProps } from './ConfirmDeletionDialog';

export type ConfirmDeletionProps = Omit<ConfirmDeletionDialogProps, 'onConfirm' | 'onReject'> & {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
};

export function confirmDeletion({
  onConfirm,
  onReject,
  ...dialogProps
}: ConfirmDeletionProps): void {
  confirmAlert({
    customUI: ({ onClose }) => (
      <ConfirmDeletionDialog
        {...dialogProps}
        onConfirm={() => {
          onConfirm();
          onClose();
        }}
        onReject={() => {
          onReject?.();
          onClose();
        }}
      />
    ),
  });
}
